$(function () {
  var param = window.location.search;
  const url = "https://media.ec-imsolution.com/cargo/";
  if (param.length === 0) {
    $("#all").addClass("selected");
    $("#camperspick__content").attr("src", url);
  } else {
    switch (getParam("ct", window.location.href)) {
      case "1":
        $("#color").addClass("selected");
        $("#camperspick__content").attr("src", url + param);
        break;
      case "2":
        $("#season").addClass("selected");
        $("#camperspick__content").attr("src", url + param);
        break;
      case "3":
        if (getParam("key", window.location.href) == "1") {
          $("#best").addClass("selected");
          $("#camperspick__content").attr("src", url + param);
        } else if (getParam("key", window.location.href) == "2") {
          $("#story").addClass("selected");
          $("#camperspick__content").attr("src", url + param);
        } else {
          $("#all").addClass("selected");
          $("#camperspick__content").attr("src", url);
        }
        break;
      default:
        $("#all").addClass("selected");
        $("#camperspick__content").attr("src", url);
    }
  }
});

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

window.addEventListener("message", (event) => {
  // 送信元のオリジンを確認
  if (event.origin !== "https://media.ec-imsolution.com") return; // 信頼できるオリジンのみ処理する

  if (event.data.data === void 0) {
    if(event.data.height !== void 0){
      $("#camperspick__content").height(event.data.height);
    }
  } else {
    const data = event.data.data;
    $('body').addClass("scroll-hidden")
    $("#camperspickPopup a img").attr("src", data.thumbnail);
    $("#camperspickPopup a").attr("href", data.igurl);
    $("#camperspickPopup .p-subject").html(data.text);
    $("#camperspickPopup").addClass("active");
    $(".camperspick-dimmed").addClass("active");
  }
});

$(document).on("click", ".p-btn-bg", function () {
  $("body").removeClass("scroll-hidden");
  $(".camperspick-dimmed").removeClass("active");
  $("#camperspickPopup").removeClass("active");
});
